import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import PresencaIntegralIcon from "../../shared/assets/img/integral/presenca_integral.png";
import CardapioIntegralIcon from "../../shared/assets/img/integral/cardapio.png";
import RotinaIntegralIcon from "../../shared/assets/img/integral/saude.png";
import { ALUNO, RESPONSAVEL } from "../Usuario/Perfil";
import Container from "../UI/Container";

const GRID_SIZE = { xs: 12, sm: 6, md: 4 };

/** Cada item tem a rota da equipe da escola e a rota de aluno/responsável. */
const MENU_ITEMS = [
  {
    titulo: "Presença",
    descricao: { equipe: "Registre a presença dos alunos no integral.", familia: "Acompanhe a presença no integral." },
    link: { equipe: "/integral-presenca", familia: "/integral-presenca-aluno" },
    imagem: PresencaIntegralIcon,
  },
  {
    titulo: "Cardápio",
    descricao: { equipe: "Cadastre o cardápio das refeições.", familia: "Veja o cardápio das refeições." },
    link: { equipe: "/cardapio", familia: "/cardapio-usuario" },
    imagem: CardapioIntegralIcon,
  },
  {
    titulo: "Rotina",
    descricao: { equipe: "Registre a rotina diária dos alunos.", familia: "Acompanhe a rotina diária do aluno." },
    link: { equipe: "/rotina", familia: "/rotina-usuario" },
    imagem: RotinaIntegralIcon,
  },
];

const IntegralMenu = () => {
  const usuario = useSelector((state) => state.usuario);
  const publico = usuario?.perfil === ALUNO || usuario?.perfil === RESPONSAVEL ? "familia" : "equipe";

  return (
    <Container>
      <Box mb={3}>
        <Typography variant="h6">Integral</Typography>
        <Typography variant="body2" color="text.secondary">
          Presença, cardápio e rotina do período integral.
        </Typography>
      </Box>

      <Grid container spacing={2}>
        {MENU_ITEMS.map(({ titulo, descricao, link, imagem }) => (
          <Grid key={titulo} size={GRID_SIZE}>
            <Card
              variant="outlined"
              sx={{
                height: "100%",
                transition: "box-shadow .2s, transform .2s",
                "&:hover": { boxShadow: 4, transform: "translateY(-2px)" },
              }}
            >
              <CardActionArea component={Link} to={link[publico]} sx={{ height: "100%" }}>
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box
                      sx={{
                        display: "flex",
                        p: 1,
                        borderRadius: 2,
                        bgcolor: "action.hover",
                        flexShrink: 0,
                      }}
                    >
                      <Box component="img" src={imagem} alt="" sx={{ width: 48, height: 48, objectFit: "contain" }} />
                    </Box>
                    <Box flexGrow={1}>
                      <Typography variant="subtitle1" fontWeight={600}>
                        {titulo}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {descricao[publico]}
                      </Typography>
                    </Box>
                    <ChevronRightIcon color="action" />
                  </Stack>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default IntegralMenu;
